import { createSlice } from "@reduxjs/toolkit"
import { ApiStatus } from "../../types/api/status"
import { PaymentVoucher, paymentVoucherType } from "../../types/slices/paymentVoucherType"
import { RootState } from "../store"

const initialState: paymentVoucherType = {
    status: ApiStatus.FETCHED,
    paymentVouchers: [],
    totalRows: 0,
    paymentVoucherSelected: {} as PaymentVoucher,
    errorMessage: undefined
}

const paymentVoucherSlice = createSlice({
    name: 'paymentVoucherSlice',
    initialState,
    reducers: {
        onFetchPaymentVouchers(state, { payload }: { payload: PaymentVoucher[] }) {
            state.status = ApiStatus.FETCHED
            state.paymentVouchers = payload
            state.errorMessage = undefined
        },
        onSetSelectedPaymentVoucher(state, { payload }: { payload: PaymentVoucher }) {
            state.paymentVoucherSelected = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        },
        onFetchTotalRows(state, { payload }: { payload: number }) {
            state.totalRows = payload
        }
    }
})

export const selectPaymentVoucherState = (state: RootState) => state.paymentVoucherSlice
export default paymentVoucherSlice.reducer
export const {
    onFetchPaymentVouchers,
    onSetSelectedPaymentVoucher,
    changeStatus,
    onFetchTotalRows
} = paymentVoucherSlice.actions